import { AxiosInstance, AxiosResponse } from "axios";
import { QuestionModel, QuestionParams } from "./question-type";
import { ApiResponse } from "../public-types";
import qs from "qs";

// TEQ02. (인증) 상담관리 등록
export async function postQuestionAsync(
  axios: AxiosInstance,
  params?: QuestionParams, //
): Promise<AxiosResponse<ApiResponse<{ content: QuestionModel }>>> {
  const path = `/api/court/et/question`;
  return await axios.post(path, {
    question: params,
    paramsSerializer: (params: QuestionParams) => qs.stringify(params, { allowDots: true, encode: true }),
  });
}

// TEQ03. (무인증) 상담관리 등록
export async function postPublicQuestionAsync(
  axios: AxiosInstance,
  params?: QuestionParams & { token: string; siteKey?: string }, //
): Promise<AxiosResponse<ApiResponse<{ content: QuestionModel }>>> {
  if (!params?.token) {
    throw Error("token is not found");
  }
  const { token, siteKey, ...payload } = params;
  const path = `/api/court/et/public/question`;
  const headers: Record<string, string> = { "X-Recaptcha-Token": token };
  // policy-based challenge 방식 사이트키를 사용하는 경우 함께 전달
  if (siteKey) {
    headers["X-Recaptcha-Site-Key"] = siteKey;
  }
  return await axios.post(
    path,
    {
      question: payload,
    },
    { headers },
  );
}
